import type { FaireProductEntity } from "../../entity_types/product";

export const p_mc6u2awatc: FaireProductEntity = {
  token: "p_mc6u2awatc",
  type: "product",
  name: "18K Gold Round Brilliant Tennis Necklace",
  brandToken: "b_byvu4wr4",
  brandName: "Brenda Grands Waterproof Jewelry",
  imageUrl:
    "https://cdn.faire.com/fastly/3b05dc82c45ac4532edea6d0f316bb227d97fe4ee347585f776f8c4427c07b17.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/26537ce4bb9edd57ee378db441a8d22145b2ef789891cb5fef53febabbf88722.jpeg",
    "https://cdn.faire.com/fastly/8aa4a8c176afb0836c512a56fed8711366207c6c3de3857ec2c29e52719a8079.jpeg",
    "https://cdn.faire.com/fastly/b9f91c82c73d215f9c987d3ec385f177f967d66c8d5240098d3ebef2eed3d56c.jpeg",
    "https://cdn.faire.com/fastly/1f3ba66c5621894288d3307bcff32fea9316a9e34d0a8f6d8338ecfe93703d7b.jpeg",
    "https://cdn.faire.com/fastly/7c75b429bc9a913869c24be3f4ae7bfef50b33c9f5706089f5960620bfa801ac.webp",
  ],
  priceDollars: 50,
  description:
    '\n * Water resistant & tarnish-free \n * 18–24K gold layered over solid brass base \n * Protective coating for lasting finish \n * Handcrafted quality \n * Nickel-free, lead-free & hypoallergenic \n * 3mm 5A CZ and 4mm total diameter including bezel \n * SIZE: 15.5" + 3" removable extender. Width 4mm ',
  tags: [],
  msrpDollars: 125,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:48:59.977Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
